import { render, staticRenderFns } from "./DPRSlider.vue?vue&type=template&id=17e0949a&scoped=true"
import script from "./DPRSlider.vue?vue&type=script&lang=js"
export * from "./DPRSlider.vue?vue&type=script&lang=js"
import style0 from "./DPRSlider.vue?vue&type=style&index=0&id=17e0949a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e0949a",
  null
  
)

export default component.exports